<template>
  <v-data-table
    class="my-4"
    hide-default-footer
    :headers="tableFields"
    :items="item.getChangedAttributes()"
    :items-per-page="numItems"
    :fields="tableFields">
    <template v-slot:item.originalValue="cell">
      <audit-log-details-formatter :type="getCellType(cell)" :value="cell.value"/>
    </template>
    <template v-slot:item.newValue="cell">
      <audit-log-details-formatter :type="getCellType(cell)" :value="cell.value"/>
    </template>
  </v-data-table>
</template>

<script>

import AuditLogDetailsFormatter from '@/components/audit-log/AuditLogDetailsFormatter'
import { size } from 'lodash'

export default {
  name: 'AuditLogDetails',
  components: {
    AuditLogDetailsFormatter
  },
  props: {
    item: {
      type: Object
    }
  },
  data () {
    return {
      tableFields: [
        {
          value: 'attribute',
          text: this.$tc('attribute')
        },
        {
          value: 'originalValue',
          text: this.$tc('original_value')
        },
        {
          value: 'newValue',
          text: this.$tc('new_value')
        }
      ]
    }
  },
  computed: {
    numItems () {
      if (this.item) {
        return size(this.item.getChangedAttributes())
      }
      return 0
    }
  },
  methods: {
    /**
     * Construct an identifier for the cell based on resource type and attribute.
     * Ex: 'route.start' and 'route.end'
     *
     * @param cell
     * @returns {string}
     */
    getCellType (cell) {
      return this.item.resource_type + '.' + cell.item.attribute
    }
  }
}
</script>
